import {Grid, IconButton} from "@mui/material";
import gear from "../../../../public/assets/icons/gear.svg";
import React from "react";

export function WorkItemSettingsBtn(props: { onClick: () => void, alt: string }) {
    return <Grid item xs={6} display={"flex"} justifyContent={"flex-end"}>
        <IconButton onClick={props.onClick}>
            <img
                src={gear}
                alt={props.alt}
                style={{height: "14px"}}
            />
        </IconButton>
    </Grid>;
}